<div class="row justify-content-md-center mt-4 footer-parent">
  <div class="col-lg-10 col-12">

    <!-- meet criterias page -->
    <div class="row mb-5">
      <div class="col-lg-10 col-12">
        <div class="page-title-small">Three things before you start:</div>
        <div class="page-title">Meet the Criteria</div>

        <div class="blue-box icon mt-4">
          <svg-icon name="info-icon" svgClass="mr-2"></svg-icon>
          This internal business valuation tool will result in the most accurate values when appraising businesses that fall
          within the following criteria:
        </div>

        <div class="mt-5">
          <div class="steps">
            <svg-icon name="revenue" svgClass="icon"></svg-icon>
            <div class="value">Revenues less than $5,000,000</div>
          </div>
          <div class="steps">
            <svg-icon name="chart" svgClass="icon"></svg-icon>
            <div class="value">Cash Flow less than $500,000</div>
          </div>
          <div class="steps">
            <svg-icon name="operation" svgClass="icon"></svg-icon>
            <div class="value">Operating for at least 12 months</div>
          </div>
          <div class="steps">
            <svg-icon name="income-statement" svgClass="icon"></svg-icon>
            <div class="value">Cannot value small businesses with Cash Flow greater than $1,500,000.</div>
          </div>
        </div>

        <div class="mt-5">
          We are working daily to create algorithms to expand these criteria, and appreciate your feedback
          - just
          click the feedback button located on the top right of each page.
        </div>
      </div>
    </div>

    <!-- needed financials page -->
    <div class="row mb-5">
      <div class="col-lg-10 col-12">
        <div class="page-title">Financials Needed</div>

        <div class="blue-box icon mt-4">
          <svg-icon name="info-icon" svgClass="mr-2"></svg-icon>
          Remember, the more financials you enter, the more accurate the estimated value will be.
        </div>

        <div class="mt-5">
          <div class="row">
            <div class="col-lg-8 col-12">
              <div class="steps">
                <svg-icon name="profit-loss" svgClass="icon"></svg-icon>
                <div class="value">You will need Income Statements (Profit & Loss) (up to 3 years of operations) to
                  create an initial report
                </div>
              </div>
              <div class="steps">
                <svg-icon name="income-statement" svgClass="icon"></svg-icon>
                <div class="value">You can enter a Current Year to Date (Interim) Income Statement now, or choose to
                  enter at a later time
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- required information page -->
    <div class="row mb-5">
      <div class="col-lg-10 col-12">
        <div class="page-title">Required Information</div>

        <div class="blue-box icon mt-4">
          <svg-icon name="info-icon" svgClass="mr-2"></svg-icon>
          You will need the following information to obtain an accurate value.
        </div>

        <div class="mt-5">
          <div>
            <span class="font-weight-bold">Seller: </span> Each owner's responsibility and # of hours worked per week
            (if you don't know yet, we'll let you choose a default and you can update it later, but this will have a
            large impact on value).
          </div>
          <div class="my-3">
            <span class="font-weight-bold">Lease: </span> Does the business lease its real estate from
            an unrelated third party (arm's length relationship) OR does the subject business entity or a
            related party own the real estate where the business is located (for example, EPC/OC structure)?
            If so, you'll need to know the fair market rent (or square footage of building, or estimated
            value of real estate).
          </div>

        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <label class="checkbox large">
              <input class="checkbox__input" type='checkbox' id="skipCheck" [value]="true"
                (change)="skipIntroduction($event.target.checked)" />
              <div class="checkbox__data">
                <div class="checkbox__indicator"></div>
                <p class="checkbox__text">
                  Okay I got it, don’t show me this again.
                </p>
              </div>
            </label>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>

<nav class="navbar fixed-bottom navbar-light bg-white border-top border py-0">
  <div class="container p-0">
    <div class="d-flex footer-buttons left">
      <button id="required-information-dashboard" type="button" [routerLink]="['/dashboard']"
        class="button ghost__button large__button w-100 d-flex justify-content-between">
        <svg-icon name="caret-left" svgClass="mr-2"></svg-icon>
        Dashboard
      </button>
    </div>
    <div class="d-flex w-20 h-100">
      <button id="required-information-next" type="button" (click)="createReport()"
        class="button primary__button large__button icon__right w-100 d-flex justify-content-between">
        Next
        <img src="../../../../../assets/images/caret-right.svg" alt="...">
      </button>
    </div>
  </div>
</nav>
